import ky from './kyextended';
import { WEBSITE_URL, WEBSITE_URL_V2 } from '../constants/APIConstants';

const createWebsite = (websiteCreds) => ky.post(WEBSITE_URL, {
    body: websiteCreds,
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
    }).json();

const getWebSite = (id) => ky.get(`${WEBSITE_URL}${id}/`, {
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
    }).json();

const getWebSites = () => ky.get(WEBSITE_URL_V2, {
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();

const updateWebSite = (websiteCreds, id) => ky.patch(`${WEBSITE_URL}${id}/`, {
    body: websiteCreds,
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
    }).json();

const deleteWebsite = (id) => ky.delete(`${WEBSITE_URL}${id}/`, {
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
    }).json();


const verifyIntegration = (url) => ky.post(`${WEBSITE_URL}verify-service-worker/`, {
    json: {sw_path: url}
}).json();


const activateDesktopPrompt = (webId, is_enabled) => ky.patch(`${WEBSITE_URL}${webId}/prompts/desktop/`, {
    json: is_enabled,
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();


const activateGDPRPrompt = (webId, is_enabled) => ky.patch(`${WEBSITE_URL}${webId}/prompts/gdpr/`, {
    json: is_enabled,
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();

const activateMobilePrompt = (webId, is_enabled) => ky.patch(`${WEBSITE_URL}${webId}/prompts/mobile/`, {
    json: is_enabled,
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();

const activateBellPrompt = (webId, is_enabled) =>  ky.patch(`${WEBSITE_URL}${webId}/prompts/bell/`, {
    json: is_enabled,
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();

const getServiceWorker = (id) => ky.get(`${WEBSITE_URL}${id}/service-worker/`, {
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).blob();


const getDesktopPrompt = (id) =>  ky.get(`${WEBSITE_URL}${id}/prompts/desktop`, {
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();

const updateDesktopPrompt = (id, formData) =>  ky.patch(`${WEBSITE_URL}${id}/prompts/desktop/`, {
    body: formData,
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();


const getMobilePrompt = (id) =>  ky.get(`${WEBSITE_URL}${id}/prompts/mobile/`, {
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();

const updateMobilePrompt = (id, formData) =>  ky.patch(`${WEBSITE_URL}${id}/prompts/mobile/`, {
    body: formData,
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();


const getGDPRPrompt = (id) =>  ky.get(`${WEBSITE_URL}${id}/prompts/gdpr/`, {
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();

const updateGDPRPrompt = (id, formData) =>  ky.patch(`${WEBSITE_URL}${id}/prompts/gdpr/`, {
    body: formData,
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();


const getBellPrompt = (id) =>  ky.get(`${WEBSITE_URL}${id}/prompts/bell/`, {
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();

const updateBellPrompt = (id, formData) =>  ky.patch(`${WEBSITE_URL}${id}/prompts/bell/`, {
    body: formData,
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();

const updateBranding = (id, is_branding_enabled) => ky.patch(`${WEBSITE_URL}${id}/`, {
    json: {is_branding_enabled},
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();

const getLockedFeatures = (webId) => ky.get(`${WEBSITE_URL}${webId}/features/`, {
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();

const getWebSiteSnippet = (webId) => ky.get(`${WEBSITE_URL}${webId}/manual-code-install/`, {
    headers: {
        Authorization: `Token ${localStorage.getItem('token')}`,
    }
}).json();

export  {
            createWebsite, getWebSites, updateWebSite, deleteWebsite, 
            verifyIntegration, activateDesktopPrompt, activateGDPRPrompt, 
            activateMobilePrompt, activateBellPrompt, getServiceWorker,
            getDesktopPrompt, updateDesktopPrompt, getMobilePrompt, 
            updateMobilePrompt, getGDPRPrompt, updateGDPRPrompt,
            getBellPrompt, updateBellPrompt, updateBranding, getLockedFeatures, 
            getWebSiteSnippet, getWebSite
        };